import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import NewPacienteFab from '../components/NewPacienteFab';
import PacientesTable from '../components/PacientesTable';

export default function PacientesHomePage() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <PacientesTable />
        </Paper>
      </Grid>
      <NewPacienteFab />
    </DashboardLayout>
  );
}
